import React, { Component } from 'react';
import offer1 from '../../images/services/PHOTO-2024-11-05-11-59-06.JPG';

class Offers extends Component{
	render(){
		
		return(
			<>
				
				<section className="section-sp1 service-wraper2">
					<div className="container">
						<div className="row">
							{/* <div className="col-xl-3 col-sm-6 mb-30">
								<div className="feature-container feature-bx3">
									<h2 className="counter text-secondary">30+</h2>
									<h5 className="ttr-title">Years Combined Experience</h5>
									<p>Trust our 30+ years of experience for your lasting oral health and peace of mind.</p>
								</div>
							</div>
							<div className="col-xl-3 col-sm-6 mb-30">
								<div className="feature-container feature-bx3">
									<h2 className="counter text-secondary">3</h2>
									<h5 className="ttr-title">Awards</h5>
									<p>Experience award-winning care for a healthier, more radiant smile.</p>
								</div>
							</div>
							<div className="col-xl-3 col-sm-6 mb-30">
								<div className="feature-container feature-bx3">
									<h2 className="counter text-secondary">3</h2>
									<h5 className="ttr-title">Doctors</h5>
									<p>You're in safe hands at our dental office, where a team of three experienced doctors collaborates to provide top-notch care, ensuring all your dental needs are expertly met.</p>
								</div>
							</div>
							<div className="col-xl-3 col-sm-6 mb-30">
								<div className="feature-container feature-bx3">
									<h2 className="counter text-secondary">250+</h2>
									<h5 className="ttr-title">5-Star Reviews</h5>
									<p>Join our thriving community of satisfied patients who trust us for exceptional dental care and have rated us with 250+ 5-star reviews.</p>
								</div>
							</div> */}
							<div className="row align-items-center">
							<div className="heading-bx text-center">
							<h6 className="title-ext text-secondary">Our Offers</h6>
							<h2 className="title m-b0">Get a Good Deal</h2>
							</div>							
							<li style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <img className="about-thumb1" src={offer1} alt="" style={{ width: '50%' }} />
    </li>							
														
							
														{/* <div className="col-lg-6 mb-30">
															<div className="heading-bx">
																<h6 className="title-ext text-secondary">Our Office</h6>
																<h2 className="title">Take a Tour!</h2>
																<p>Welcome to our state-of-the-art, eco-friendly dental office, where cutting-edge technology meets sustainable design. As you explore the space, you'll notice sleek, modern furnishings paired with energy-efficient lighting, all crafted with eco-conscious materials. From our advanced sterilization systems to water-saving dental equipment, every detail reflects our commitment to providing top-tier care while minimizing environmental impact. Experience a calm, welcoming atmosphere designed with patient comfort in mind, ensuring that your visit is both relaxing and environmentally responsible.</p>
															</div>
															
														</div> */}
													
													</div>
						</div>
					</div>
				</section>
				
			</>
		);
	}
}

export default Offers;